import { useDebugValue } from 'react';
import { isNull } from 'utils/tsHelpers';
import { ElementType, useIndex } from '../../../contexts/elementIndex';
import { useClauseConditionsFieldPath } from './useClauseConditionsFieldPath';

export const useConditionFieldPath = () => {
  const clauseConditionsFieldPath = useClauseConditionsFieldPath();
  const index = useIndex(ElementType.condition);
  if (isNull(index)) {
    throw new Error('Cannot determine condition field path: no condition index in context');
  }
  const fieldPath = `${clauseConditionsFieldPath}.${index}` as const;
  useDebugValue(fieldPath);
  return fieldPath;
};
